import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  FormControlLabel,
  Switch,
  Typography,
  Divider,
} from "@mui/material";
import { useConsent } from "./ConsentProvider";
import { useTranslate } from "src/locales";

export default function CookiePreferences() {
  const { t } = useTranslate();
  const { preferencesOpen, closePreferences, consent, setConsent } =
    useConsent();
  const [draft, setDraft] = React.useState(consent);

  React.useEffect(() => setDraft(consent), [consent, preferencesOpen]);

  const save = () => {
    setConsent({ ...draft, necessary: true });
    closePreferences();
  };

  return (
    <Dialog
      open={preferencesOpen}
      onClose={closePreferences}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{t("cookie_preferences_title")}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Section
            title={t("cookies_necessary_title")}
            description={t("cookies_necessary_desc")}
            control={<Switch checked disabled />}
          />
          <Divider />
          <Section
            title={t("cookies_analytics_title")}
            description={t("cookies_analytics_desc")}
            control={
              <Switch
                checked={draft.analytics}
                onChange={(e) =>
                  setDraft((d) => ({ ...d, analytics: e.target.checked }))
                }
              />
            }
          />
          <Divider />
          <Section
            title={t("cookies_marketing_title")}
            description={t("cookies_marketing_desc")}
            control={
              <Switch
                checked={draft.marketing}
                onChange={(e) =>
                  setDraft((d) => ({ ...d, marketing: e.target.checked }))
                }
              />
            }
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={closePreferences} color="inherit">
          {t("cancel")}
        </Button>
        <Button onClick={save} variant="contained">
          {t("save_preferences")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Section({
  title,
  description,
  control,
}: {
  title: string;
  description: string;
  control: React.ReactNode;
}) {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Stack flex={1}>
        <Typography variant="subtitle1" fontWeight={600}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Stack>
      <FormControlLabel control={control as any} label="" />
    </Stack>
  );
}
